import { Component, OnInit, Input } from "@angular/core";
import { SaleItem, SaleOrder } from "@tendercuts/models";
import { PosQuote } from '../../../models';

/**
 * component is used to display the child components in the order history detail page
 */
@Component({
  selector: "app-combo-list",
  templateUrl: "./combo-list.html",
  styleUrls: ["./combo-list.scss"],
})
export class ComboListComponent implements OnInit {
  // read the items from the saleorder
  @Input() selectedItem: SaleItem;
  // this will be shown only in order history page
  @Input() order: SaleOrder;
  // assign selected comboItem related child items
  comboChildItems: SaleItem[] = [];

  constructor() {}

  ngOnInit() {
    const items: SaleItem[] = this.order.items;
    this.comboChildItems = items.filter(
      (item: SaleItem) => item.parentItemId == this.selectedItem.itemId
    );
  }
}
